var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('i', {
    staticClass: "alarm-level-icon",
    class: [_vm.iconClass, _vm.variantClass, {
      'alarm-level-icon--large': _vm.large
    }]
  });

}
var staticRenderFns = []

export { render, staticRenderFns }